module.exports = __webpack_public_path__ + "img/automation3.b9ecdebb.png";